var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full w-full relative overflow-hidden"},[(_vm.loading)?_c('loader'):(_vm.initialized)?_c('router-view'):_vm._e(),_c('portal-target',{attrs:{"name":"modal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }